import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";

export function useRumTracking() {
  const location = useLocation();

  useEffect(() => {
    const viewName = location.pathname || "/";

    try {
      datadogRum.startView({
        name: viewName,
      });
    } catch (error) {
      console.error("[RUM Tracking] Error:", error);
    }
  }, [location.pathname]);

  return null;
}
